import i18n from "locales"

export const getStepsList = () => [
    { label: i18n.t("selectExercise", { ns: "question" }), isCompleted: true },
    { label: i18n.t("selectVariable", { ns: "question" }), isCompleted: false }
]
